import loopbackRestClient, { authClient } from './dataProvider';

const API_URL = process.env.REACT_APP_API_URL;

export const dataProvider = loopbackRestClient(API_URL);
export const authProvider = authClient(`${API_URL}/users/login`);